import React, {useContext, useState} from 'react';
import IconButton from '@material-ui/core/IconButton';
import WarningIcon from '@material-ui/icons/Warning';
import CloseIcon from '@material-ui/icons/Close';
import SnackbarCore from "@material-ui/core/Snackbar";

export const SnackbarContext = React.createContext();
export const useSnackbarContext = () => useContext(SnackbarContext);
export const SnackbarProvider = ({children}) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");

    function handleMessageUpdate(value) {
        if (value === message) return;

        setOpen(!!value);
        setMessage(value);
    }

    return (
        <SnackbarContext.Provider
            value={{
                open,
                message,
                handleMessageUpdate
            }}>
            {children}
        </SnackbarContext.Provider>
    );
};

function handleSnackbarCloseOnClick(event, reason, handleMessageUpdate) {
    if (reason === 'clickaway') return;

    handleMessageUpdate(null);
}

export default function Snackbar() {
    const {open, message, handleMessageUpdate} = useSnackbarContext();

    return (
        <SnackbarCore
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            open={open}
            autoHideDuration={5000}
            onClose={(e, r) => handleSnackbarCloseOnClick(e, r, handleMessageUpdate)}
            ContentProps={{'aria-describedby': 'message-id',}}
            message={
                <span
                    id="client-snackbar"
                    style={{display: 'flex', alignItems: 'center'}}
                >
                    <WarningIcon
                        style={{
                            fontSize: 20,
                            opacity: 0.9,
                            marginRight: 15
                        }}/>
                    {message}
                </span>
            }
            action={[
                <IconButton
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    onClick={(e) => handleSnackbarCloseOnClick(e, "icon-close-button", handleMessageUpdate)}
                >
                    <CloseIcon style={{fontSize: 20}}/>
                </IconButton>
            ]}
        />
    );
}